// Legacy id of the retired "All Data Assets" dataset. Only still used as a fallback
// key in useDraftConfig (the bucket for migrated single-config CE drafts) and
// CreateCohort, as well as tests.
export const DEFAULT_DATASET_ID = "00000000-0000-0000-0000-000000000000";
